import { Icon } from "components/icon/Icon";
import { ErrorItem } from "models/errors/errors";

import "./InformationItem.scss";
import { useState } from "react";

type Props = {
  onCloseClick: (error: ErrorItem) => void;
  error: ErrorItem;
};

export default function InformationItem({ onCloseClick, error }: Props) {
  const handleOnCloseClick = () => {
    onCloseClick(error);
  };

  const [showAdditionalErrorMessage, setShowAdditionalErrorMessage] =
    useState(false);

  const isWarningMessage = error.type === "warning";

  const getShowMoreIcon = (iconType: string, showMore: boolean) => (
    <div className="text-right">
      <Icon
        name={`fas ${iconType}`}
        onClick={() => setShowAdditionalErrorMessage(showMore)}
      />
    </div>
  );

  const warningMessageContent = <p className="errorText">{error.errorText}</p>;
  const errorMessageContent = (
    <div>
      <p className="errorText">{error.errorText}</p>
      {!showAdditionalErrorMessage &&
        error.additionalErrorText !== "" &&
        getShowMoreIcon("fa-chevron-down", true)}
      {showAdditionalErrorMessage && (
        <>
          {getShowMoreIcon("fa-chevron-up", false)}
          <div className="break-word details-container">
            <p>Error Details</p>
            <span>
              {error.statusCode && `${error.statusCode}:`}
              {error.additionalErrorText && error.additionalErrorText}
            </span>
          </div>
        </>
      )}
    </div>
  );

  const errorHeaderText = !isWarningMessage ? "Felmeddelande" : "Varning";

  return (
    <li className="informationItemLayout errorType">
      <section className="container">
        <div
          className={`errorIcon ${isWarningMessage ? "errorIconWarning" : ""}`}
        >
          <Icon name="exclamation-triangle" />
        </div>
        <div className="textInfo w-100">
          <strong className="statusText">{errorHeaderText}</strong>
          {!isWarningMessage ? errorMessageContent : warningMessageContent}
        </div>
        <div className="close">
          <Icon name="times" onClick={handleOnCloseClick} />
        </div>
      </section>
    </li>
  );
}
